import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const AddDineType = ({ open, close, setLoading, rerun }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleCreateDineType = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-dine-type", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Created new dine type successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Dine Type"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-dine-type"
        initialValues={{ remember: true }}
        onFinish={handleCreateDineType}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="dine_type"
            label="Dine Type"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input
              // placeholder="Set dine type"
              size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddDineType;
